module.exports = __webpack_public_path__ + "img/upperCaseY.4f475115.svg";